function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
import VMenu from '@cloud-sn/v-menu';
import { isEqual } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
var __vue_script__ = {
  name: buildComponentName('Menu'),
  components: {
    VMenu: VMenu
  },
  provide: function provide() {
    return {
      menuWrap: this
    };
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-menu'
    },
    theme: {
      type: String,
      default: 'light'
    },
    mode: {
      type: String,
      default: 'inline',
      validator: function validator(v) {
        return v === 'vertical' || v === 'horizontal' || v === 'inline';
      }
    },
    inlineIndent: {
      type: Number,
      default: 24
    },
    selectedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    openKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default: true
    },
    uniqueOpened: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    inlineCollapsed: {
      type: Boolean,
      default: false
    },
    hasTitleAttr: {
      type: Boolean,
      default: false
    },
    isDropdownMenu: {
      type: Boolean,
      default: false
    },
    getPopupContainer: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      isWrap: true,
      innerOpenKeys: [],
      collapsedOpenKeys: []
    };
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls,
          inlineCollapsed = this.inlineCollapsed;
      return _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), inlineCollapsed);
    },
    bindProps: function bindProps() {
      var $props = this.$props,
          inlineCollapsed = this.inlineCollapsed,
          mode = this.mode,
          collapsedOpenKeys = this.collapsedOpenKeys;
      return _objectSpread({}, $props, {
        mode: inlineCollapsed ? 'vertical' : mode,
        openKeys: collapsedOpenKeys
      });
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners,
          onOpenChange = this.onOpenChange;
      return _objectSpread({}, $listeners, {
        'open-change': onOpenChange
      });
    }
  },
  watch: {
    openKeys: function openKeys(nVal, oVal) {
      if (!isEqual(nVal, oVal)) {
        var inlineCollapsed = this.inlineCollapsed;
        var val = nVal || [];
        this.setOpenKeys(val);
        this.prevCollapsedOpenKeys = val;

        if (!inlineCollapsed) {
          this.collapsedOpenKeys = val;
        }
      }
    },
    inlineCollapsed: function inlineCollapsed() {
      this.updateCollapseOpenKeys();
    }
  },
  created: function created() {
    var val = this.openKeys || [];
    this.setOpenKeys(val); // no reactive

    this.prevCollapsedOpenKeys = val; // no reactive

    this.updateCollapseOpenKeys();
  },
  methods: {
    setOpenKeys: function setOpenKeys(keys) {
      this.innerOpenKeys = keys;
    },
    onOpenChange: function onOpenChange(keys) {
      this.setOpenKeys(keys);
      this.$emit('open-change', keys);
    },
    updateCollapseOpenKeys: function updateCollapseOpenKeys() {
      var _this = this;

      var inlineCollapsed = this.inlineCollapsed,
          innerOpenKeys = this.innerOpenKeys;

      if (inlineCollapsed) {
        this.prevCollapsedOpenKeys = innerOpenKeys;
        this.collapsedOpenKeys = [];
      } else {
        setTimeout(function () {
          _this.collapsedOpenKeys = _this.prevCollapsedOpenKeys;
          _this.prevCollapsedOpenKeys = [];
        }, 100);
      }
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', _vm._g(_vm._b({
    class: _vm.classes
  }, 'v-menu', _vm.bindProps, false), _vm.bindListeners), [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "menu.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;